import light from './light';

const themes = [light];

export default themes;
